import USER_TYPES from '@/constants/authorization/user-types'
import store from '@/store'

export default [
  {
    title: 'inventory.title',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
    svgIcon: 'icon-inventory',
    hide: () => !store.getters['subscription/hasInventory'],
    children: [
      {
        title: 'inventory.units.title',
        svgIcon: 'icon-units',
        route: 'admin:inventory:units',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
      {
        title: 'inventory.suppliers.title',
        svgIcon: 'icon-suppliers',
        route: 'admin:inventory:suppliers',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
      {
        title: 'inventory.items.ingredients',
        svgIcon: 'icon-inventory-items',
        route: 'admin:inventory:ingredients',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
      {
        title: 'inventory.items.recipes',
        svgIcon: 'icon-inventory-recipes',
        route: 'admin:inventory:recipes',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
      {
        title: 'inventory.items.count',
        svgIcon: 'icon-inventory-count',
        route: 'admin:inventory:branches',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
      {
        title: 'inventory.transactions.title',
        svgIcon: 'icon-inventory-transactions',
        route: 'admin:inventory:transactions',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
      {
        title: 'inventory.report.title',
        svgIcon: 'icon-stock-report',
        route: 'admin:inventory:report',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER],
      },
    ],
  },

]
